module.exports = __webpack_public_path__ + "img/index_hotimg1.7647fe58.jpg";